import { render, staticRenderFns } from "./class-admin.view.vue?vue&type=template&id=f3af4444&scoped=true&"
import script from "./class-admin.view.ts?vue&type=script&lang=ts&"
export * from "./class-admin.view.ts?vue&type=script&lang=ts&"
import style0 from "./class-admin.view.scss?vue&type=style&index=0&id=f3af4444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3af4444",
  null
  
)

export default component.exports